import React from "react"
import Helmet from "react-helmet"
import Uninstall from "@tightrope/footerlinks/uninstall"
import HomepageLayout from "src/layouts/homepage"
import JSONData from "branding/site-metadata.json"
import RawFooter from "@tightrope/footerlinks/rawfooter.js"
import styles from 'src/styles/shared/legal-pages.module.scss'

export default function UninstallPage() {
  return(
    <HomepageLayout>
        <Helmet data={JSONData}>
          <link rel="icon" href="/img/favicon.png" sizes="32x32" />
          <title>Uninstall | AllSearch</title></Helmet>
        <div className={styles.legalPage}>
        <header style={{backgroundImage: "#eaf5ef", border: "1px solid #4e5052"}}>
            <img src="/img/allsearch-logo.svg" alt="AllSearch Logo" />
                </header>
            <div className={styles.container}>
                <Uninstall hideFooter={true} />
            </div>
        </div>
        <RawFooter />
    </HomepageLayout>
  )
}
